import { createContext, use } from 'react';

export const BlockchainBlockNumberContext = createContext<bigint | undefined>(
  undefined
);

export const useBlockchainBlockNumber = () => use(BlockchainBlockNumberContext);
